import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";

export default function HeroSection() {
  const topArticles = featuredArticles.slice(0, 3);

  return (
    <section className="relative w-full pt-16 md:pt-18">
      <div className="w-full px-4 md:px-10 py-8 md:py-14">
        <nav className="mb-6" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-xs">
            <li>
              <Link to="/" className="text-foreground-400 hover:text-foreground-700 whitespace-nowrap cursor-pointer transition-colors duration-200">
                首页
              </Link>
            </li>
            <li>
              <span className="text-foreground-300">/</span>
            </li>
            <li>
              <span className="text-accent-600 font-medium">热门推荐</span>
            </li>
          </ol>
        </nav>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[40%] flex flex-col justify-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-5">
              全网黑料大全<br />免费吃瓜爆料
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-7 max-w-md">
              24小时不打烊的黑料传送门。聚合全网最新鲜的网红八卦、明星黑料与娱乐热点，做全网吃瓜群众的第一资讯入口。每日大赛不见不散，免费吃瓜永不打烊。
            </p>
            <div className="flex gap-3">
              <Link
                to="/category/shishi-redian"
                className="whitespace-nowrap px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer hover:bg-primary-600 transition-colors duration-200"
              >
                立即吃瓜
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-semibold cursor-pointer hover:border-foreground-500 hover:text-foreground-950 transition-colors duration-200"
              >
                我要爆料
              </Link>
            </div>
          </div>

          <div className="lg:w-[60%]">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {topArticles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className={`cursor-pointer group ${
                    index === 0 ? "col-span-2" : "col-span-1"
                  }`}
                >
                  <div
                    className={`relative rounded-xl overflow-hidden ${
                      index === 0 ? "h-48 md:h-64" : "h-36 md:h-48"
                    }`}
                  >
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                      <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-1.5">
                        {article.categoryName}
                      </span>
                      <h3 className={`text-white font-semibold line-clamp-2 ${index === 0 ? "text-sm md:text-base" : "text-xs md:text-sm"}`}>
                        {article.title}
                      </h3>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}